var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-box display-flex"},[_c('div',{staticClass:"logout-box margin-horizontal-auto display-flex flex-column"},[_c('bbox-icon',{attrs:{"spin":""}},[_c('icon-refresh',{staticClass:"font-size-xhuge"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }